<template>
  <v-container id="registration-acknowledge" fluid>
    <v-row align="center" justify="center">
      <v-col xs="12" sm="8" md="6">
        <v-card flat>
          <v-card-title>
            <v-img
              alt="Sharylist Logo"
              contain
              class="mr-2"
              src="@/assets/logo.png"
              transition="scale-transition"
              max-width="35"
            />
            {{ $route.params.newUser.firstName }}, thanks for registering
          </v-card-title>
          <v-card-text class="text-body-1">
            <p>We have just <span class="font-weight-medium">sent you a message</span> to:</p>

            <p class="font-weight-medium text-center">
              {{ $route.params.newUser.email }}
            </p>

            <p>with a <span class="font-weight-medium">temporary password</span> to login.</p>
            <br />
            <p>
              <span class="font-weight-black primary--text">Check your inbox now</span> and use your
              email address and the temporary password we sent you to login. Please, change the
              password as soon as possibile in the Account page.
            </p>
            <p class="font-weight-medium text-right">Enjoy Sharylist!</p>
          </v-card-text>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined large color="primary" to="/login">
              <v-icon left>mdi-login</v-icon>
              Login
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      //
    }
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
    this.nodeCurrentSet({})
  },

  methods: {
    ...mapMutations(['nodeCurrentSet', 'errorsDataAccessAllSetFalse']),
  },
}
</script>
